import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import icons from '../icons';
import light from '../themes/light';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdiSvg',
        values: icons,
    },
    theme: {
        options: {
            customProperties: true,
            variations: false,
        },
        themes: { light },
    },
});
